<script lang="ts">
    import Icon from "@components/Icon.svelte";
    import CloseIcon from "@components/icons/CloseIcon.svelte";
</script>

<div class="gw-rv-gallery__close-icon">
    <Icon height="22" width="22">
        <CloseIcon />
    </Icon>
</div>

<style lang="postcss">
    :global(.gw-rv-gallery__close-icon) {
        width: 22px;
        height: 22px;

        @media screen and (max-width: 1000px) {
            color: white;
            background-color: rgba(0, 0, 0, 0.3);
        }

        @media screen and (max-width: 600px) {
            color: black;
            background-color: transparent;
        }
    }
</style>
